import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var SuggestionOffer = /** @class */ (function () {
    function SuggestionOffer(obj, id) {
        if (id) {
            this.id = id;
        }
        if (obj.position) {
            this.position = obj.position;
        }
        console.log('obj', obj);
        this.product_id = _.get(obj, 'product.id', _.get(obj, 'product'));
        // used only for formatting to dropdown option so it can be loaded in the control instantly 
        this.product_formatted = obj.product ? new DropdownOption({
            label: _.get(obj, 'product.attributes.name'),
            value: _.get(obj, 'product.id'),
        }) : null;
    }
    Object.defineProperty(SuggestionOffer.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuggestionOffer.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuggestionOffer.prototype, "Product", {
        get: function () {
            return this.product_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuggestionOffer.prototype, "ProductFormatted", {
        get: function () {
            return this.product_formatted;
        },
        enumerable: false,
        configurable: true
    });
    return SuggestionOffer;
}());
export { SuggestionOffer };
export function createSuggestionOffer(obj, id) {
    return new SuggestionOffer(obj, id);
}
export function createSuggestionOffers(rawSuggestionOffers) {
    var suggestionOffers = [];
    var rawSuggestionOffersData = rawSuggestionOffers.data;
    for (var _i = 0, rawSuggestionOffersData_1 = rawSuggestionOffersData; _i < rawSuggestionOffersData_1.length; _i++) {
        var rawSuggestionOffer = rawSuggestionOffersData_1[_i];
        var suggestionOffer = createSuggestionOffer(rawSuggestionOffer.attributes, rawSuggestionOffer.id);
        suggestionOffers.push(suggestionOffer);
    }
    return suggestionOffers;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/suggestionOffer/suggestionOffer.ts
// module id = 135
// module chunks = 0